import { CatalogPreloader } from "./CatalogPreloader";

export default CatalogPreloader;
